import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  selector: 'app-box-tab',
  templateUrl: './box-tab.component.html',
  styleUrls: ['./box-tab.component.scss'],
  imports: [CommonModule, CeIconComponent, MatTabsModule, MatTooltipModule],
})
export class BoxTabComponent implements OnInit, AfterContentInit, OnChanges {
  private _boxContent: any[] = [
    {
      label: 'Tab name',
      tooltip: 'Tab tooltip',
      id: 'box-tab-pane',
      active: true,
      icon: 'info',
    },
    {
      label: 'Tab name2',
      tooltip: 'Tab tooltip2',
      id: 'box2-tab-pane',
      active: false,
      icon: 'info',
    },
  ];

  protected selectedIndex = 0;

  @Output() selectedTab = new EventEmitter<string>();

  @Input()
  tabId = 'myTab';

  @Input()
  Size: 'medium' | 'large' = 'medium';

  @Input() showLabel: boolean = true;

  get boxContent(): any[] {
    return this._boxContent;
  }

  @Input() set boxContent(value: any[]) {
    this._boxContent = value ? JSON.parse(JSON.stringify(value)) : [];
    this.updateSelectedIndex();
  }

  @ContentChildren(TemplateRef) contentTemplates!: QueryList<TemplateRef<any>>;
  tabTemplates: { [key: string]: TemplateRef<any> } = {};

  ngOnInit(): void {
    this.updateSelectedIndex();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['boxContent']) {
      this.updateSelectedIndex();
    }
  }

  ngAfterContentInit(): void {
    // Map tab IDs to templates
    this._boxContent.forEach((tab, index) => {
      this.tabTemplates[tab.id] = this.contentTemplates.toArray()[index];
    });
  }

  private updateSelectedIndex(): void {
    this.selectedIndex = this._boxContent.findIndex(tab => tab.active);
    if (this.selectedIndex === -1) {
      this.selectedIndex = 0;
    }
  }

  getActiveTabIndex(): number {
    const index = this._boxContent.findIndex(tab => tab.active);
    return index !== -1 ? index : 0;
  }

  onTabChange(index: number): void {
    this._boxContent.forEach((tab, i) => (tab.active = i === index));
    this.selectedTab.emit(this._boxContent[index].id);
  }
}
